<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<dialogBox :dialogFlag="fxFlag" @qrsFn="subFn" @callFn="fxFlag = false" :title="'分享班级'">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="选择班级" prop="bjId">
					<el-select style="width: 100%" v-model="ruleForm.bjId" filterable allow-create default-first-option placeholder="请选择班级">
						<el-option v-for="(item, index) in bjList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<crumbs :txt="a" type="2" :crumFlag="crumFlag" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="mqBox">
				<div class="mqBoxTop">
					<div class="mqBoxTopBtns" @click="fxFlag = true">
						<img src="@/assets/img/fxIcon.svg" alt="" />
						<span>分享班级</span>
					</div>
					<div class="mqBoxTopCont">
						<div class="mqBoxTopImg">
							<el-image :src="$imgUrl + perData.coverImg" lazy></el-image>
						</div>
						<div class="mqBoxTopR">
							<h2>{{ perData.title }}</h2>
							<p v-html="perData.content"></p>
						</div>
					</div>
				</div>
				<div class="tlTabs">
					<div class="tlTabItem" @click="tabFlag = 1" :class="{ active: tabFlag == 1 }">
						<img src="@/assets/img/xuex.png" v-show="tabFlag == 1" alt="" />
						<img src="@/assets/img/xuex (3).svg" v-show="tabFlag == 2" alt="" />
						<span>模拟学习</span>
					</div>
					<div class="tlTabItem" @click="tabFlag = 2" :class="{ active: tabFlag == 2 }">
						<img src="@/assets/img/xuex (2).svg" v-show="tabFlag == 2" alt="" />
						<img src="@/assets/img/xuex (1).svg" v-show="tabFlag == 1" alt="" />
						<span>全屏解析</span>
					</div>
				</div>
				<div class="tlCont">
					<div class="tlTit">
						{{ tabFlag == 1 ? '目 录' : '答案解析' }}
					</div>
					<div class="tlMl">
						<div class="tlTm" v-for="(sItem, sIndex) in perData.yydTextbookDirectoryList" :key="sIndex">
							<h2>{{ sItem.name }}</h2>
							<div class="tlJd" v-for="(item, index) in sItem.children" :key="index">
								<!-- <div v-if="item.yydTextbookQuestions.length"> -->
								<div v-if="item.yydTextbookQuestionsLength">
									<p @click="isFn(item)">{{ item.name }}</p>
									<div class="tlZjImg" v-for="(d, a) in item.anchorName ? i.anchorName?.split(',') : ''" :key="a">
										<img src="@/assets/img/形状 2.png" alt="" />
										{{ d }}
									</div>
								</div>
								<div v-else>
									<h3>{{ item.name }}</h3>
									<div class="tlZj" v-for="(i, s) in item.children" :key="s">
										<p @click="isFn(i)">{{ i.name }}</p>
										<div class="tlZjImg" v-for="(d, a) in i.anchorName ? i.anchorName?.split(',') : ''" :key="a">
											<img src="@/assets/img/形状 2.png" alt="" />
											{{ d }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<fullScreen :tmDec="tmDec" v-if="fullFlag" @gbFn="fullFlag = false" ref="fullBoxs" />
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import dialogBox from '@/components/pubComponents/dialogBox';
import fullScreen from '@/page/user/fullScreen.vue';

export default {
	name: 'tingliDec',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4电影
			tabFlag: 1,
			fullscreenLoading: false,
			txt: '',
			fxFlag: false,
			perData: {},
			ruleForm: {
				bjId: ''
			},
			rules: {
				bjId: [{ required: true, message: '请选择班级', trigger: 'change' }]
			},
			bjList: '', // 班级信息
			textbookId: '',
			a: ['个人中心'],
			fullFlag: false,
			tmDec: '',
			fullscreen: '',
			crumFlag: false
		};
	},
	components: {
		userHeader,
		crumbs,
		fullScreen,
		dialogBox,
		foot
	},
	methods: {
		subFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log(8888);
					let { bjId } = this.ruleForm;
					let set = this.$loading(this.$pre);
					this.$http.post(`api/app/yydUserTextbook/add/${this.textbookId}/${bjId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								message: '分享成功',
								type: 'success'
							});
							this.fxFlag = false;
						}
					});
					this.$refs.ruleForm.resetFields();
				}
			});
		},
		isFn(item) {
			console.log(item, 'sss');
			item.tabTxt = this.a;
			if (this.tabFlag == 2) {
				this.fullscreenLoading = true;
				this.$http
					.get(`api/app/yydTextbook/${this.textbookId}/directory/${item.textbookDirectoryId}/questions`, {
						params: {
							textbookId: this.textbookId,
							textbookDirectoryId: this.textbookDirectoryId,
						}
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							item.yydTextbookQuestions = res.data
							this.tmDec = JSON.stringify(item);
							this.fullFlag = true;
							this.$nextTick(() => {
								this.$refs['fullBoxs'].onFullScreen();
							});
						}
					});
				
				
				// this.$router.push({
				//   path: './fullScreen',
				//   query: {
				//     tmDec: JSON.stringify(item),
				//   }
				// })
			} else {
				let str = this.a[1] + '~' + item.name;
				this.$router.push({
					path: './kaoshi',
					query: {
						txt: str,
						tabFtxt: '听力课本列表',
						templateId: item.templateId,
						textbookDirectoryId: item.textbookDirectoryId,
						textbookId: this.perData.textbookId
					}
				});
			}
		},
		init() {
			this.$http.get(`api/app/yydBj/list`).then((res) => {
				if (res.code == 200) {
					console.log(res, 444);
					this.bjList = res.rows || [];
				}
			});
			this.fullscreenLoading = true;
			// this.$http
			// 	.get(`api/app/yydTextbook/${this.textbookId}`, {
			// 		params: {
			// 			textbookId: this.textbookId
			// 		}
			// 	})
			// 	.then((res) => {
			// 		this.fullscreenLoading = false;
			// 		if (res.code == 200) {
			// 			this.perData = res.data;
			// 		}
			// 	});
			
			this.$http
				.get(`api/app/yydTextbook/${this.textbookId}/lazy`, {
					params: {
						textbookId: this.textbookId
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.data;
					}
				});
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		}
	},
	mounted() {
		const { type, txt, tabFtxt, textbookId, crumFlag } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.textbookId = textbookId || '';
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
		if (crumFlag) {
			this.crumFlag = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.mqBox {
	width: 1200px;
	margin: 0 auto 10px;
	.tlTabs {
		margin-bottom: 10px;
		padding: 4px;
		background: #fff;
		border-radius: 4px;
		display: flex;
		.tlTabItem {
			flex: 1;
			height: 48px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
			color: #6d6e70;
			border-radius: 4px;
			cursor: pointer;
			img {
				width: 26px;
				height: 26px;
				margin-right: 5px;
			}
			:first-of-type {
				margin-right: 4px;
			}
		}
		.active {
			background: linear-gradient(180deg, #1d7b3a 0%, #1d7b3a 100%);
			color: #fff;
		}
	}
	.tlCont {
		background: #ffffff;
		padding: 31px 38px 26px;
		color: #000000;
		box-sizing: border-box;
		min-height: calc(100vh - 648px);
		.tlTit {
			font-size: 26px;
			margin-bottom: 24px;
			font-weight: bold;
		}
		.tlMl {
			.tlTm {
				.tlJd {
					margin-bottom: 29px;
				}
				h2 {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 17px;
				}
				h3 {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 14px;
				}
				p {
					color: #000000;
					font-size: 16px;
					cursor: pointer;
					&:hover {
						color: #1d7b3a;
					}
				}
				.tlZj {
					margin-bottom: 13px;
					display: flex;
					align-items: center;
					.tlZjImg {
						display: flex;
						width: 68px;
						height: 24px;
						background: #f5f5f5;
						border-radius: 4px;
						align-items: center;
						justify-content: center;
						font-size: 14px;
						color: #878a88;
						margin-left: 20px;
						cursor: pointer;
						img {
							width: 14px;
							height: 14px;
							margin-right: 5px;
						}
					}
				}
			}
		}
	}
	.mqBoxTop {
		margin-bottom: 10px;
		background: #fff;
		border-radius: 6px;
		padding: 9px 17px 14px;
		position: relative;
		.mqBoxTit {
			height: 47px;
			display: flex;
			align-items: center;
			color: #8f9190;
			font-size: 12px;
			span {
				margin-right: 27px;
			}
		}
		.mqBoxTopBtns {
			position: absolute;
			cursor: pointer;
			right: 14px;
			top: 14px;
			width: 100px;
			height: 36px;
			background: #1d7b3a;
			border-radius: 7px;
			border: 1px solid #14652d;
			color: #fff;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 13px;
				height: 14px;
				margin-right: 7px;
			}
		}
		.mqBoxTopCont {
			display: flex;
			.mqBoxTopImg {
				width: 134px;
				height: 165px;
				border-radius: 12px;
				margin-right: 26px;
				img {
					border-radius: 12px;
				}
			}
			.mqBoxTopR {
				padding-top: 9px;
				flex: 1;
				h2 {
					color: #000000;
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 25px;
				}
				p {
					color: #8f9190;
					font-size: 14px;
					line-height: 1.8;
				}
			}
		}
	}
}
</style>
